import { Component } from '@angular/core';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { CaseType } from '../_types/case-type';
import { CasesTypesService } from '../_services/cases-types.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { firstValueFrom } from 'rxjs';
import { LoginService } from '../../login/login.service';
import { CasesModesService } from '../../cases/_services/cases-modes.service';
import { CaseTypeCaseModeService } from '../_services/case-type-case-mode.service';

@Component({
    selector: 'app-cases-types-detail',
    templateUrl: './cases-types-detail.component.html',
    styleUrls: ['./cases-types-detail.component.scss'],
    standalone: false
})
export class CasesTypesDetailComponent {
  public caseTypeFormGroup!: RxFormGroup;
  public caseType: CaseType = new CaseType();
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;

  public caseModes: any[] = [];
  public selectedCaseModeIds: string[] = [];

  constructor(
    private casesTypesService: CasesTypesService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private route: ActivatedRoute,
    private router: Router,
    private topbarService: TopbarService,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private loginService: LoginService,
    private casesModesService: CasesModesService,
    private caseTypeCaseModeService: CaseTypeCaseModeService,
  ) {

    this.caseTypeFormGroup = this.formBuilder.formGroup<CaseType>(this.caseType) as RxFormGroup;
  }

  async ngOnInit() {
    this.topbarService.setTitle("Detalle de tipo de daño");
    this.topbarService.addBreadcrumb("Tipos de daño", "/casesTypes");
    await this.loadCaseModes();
    let id = this.route.snapshot.params['id'];
    if (id != null && id != '0') {
      await this.loadCaseType(id);
    }
    this.allowWrite = this.loginService.hasPermission("CASES_TYPES.WRITE");
    this.allowDelete = this.loginService.hasPermission("CASES_TYPES.DELETE");

  }

  async loadCaseModes() {
    //sin sort, por decision expresa: cases_modes no tiene columna de orden, y ordenar por
    //nombre cambiaria el orden de los switches respecto al que hay hoy
    let response = await firstValueFrom(this.casesModesService.all());
    this.caseModes = response.data;
  }

  async loadCaseType(id: string) {
    this.caseType = await firstValueFrom(this.casesTypesService.get(id));
    this.caseTypeFormGroup.patchValue(this.caseType);
    this.selectedCaseModeIds = await this.caseTypeCaseModeService.loadModeIdsFor(id);

  }

  async save() {
    let valid = this.formValidationService.validateForm(this.caseTypeFormGroup);
    if (valid) {
      this.caseType = Object.assign(this.caseType, this.caseTypeFormGroup.value);
      //primero el tipo, despues las relaciones, y solo entonces navegar
      let caseType = await firstValueFrom(this.casesTypesService.save(this.caseType));
      await this.caseTypeCaseModeService.replaceForCaseType(caseType.id!, this.selectedCaseModeIds);
      this.messageService.add({ closable: true, severity: 'success', summary: "Tipo de daño guardado correctamente." });
      this.router.navigate(['casesTypes']);
    } else {
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Existen errores, por favor revise el formulario de datos." });
    }
  }

  async delete() {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar el tipo de daño?",
      header: "Eliminar tipo de daño",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.casesTypesService.delete(this.caseType.id).subscribe({
          next: (data: any) => {
            this.cancel();
            this.messageService.add({ closable: true, severity: 'success', detail: "Tipo de daño eliminado correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
  }

  cancel() {
    this.router.navigate(['casesTypes']);
  }

}
